import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseEntity from "./BaseEntity";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";

@inheritSerialization(BaseEntity)
export default class Seragam extends BaseEntity {

	@serialize
	@deserialize
	public nama: string = "";

	@serialize
	@deserialize
	public tahun: string = "";

	@serialize
	@deserialize
	public pendidikan: string = "";

	@serialize
	@deserialize
	public ukuran: string = "";

	public file: any = null;

	public fileFeedback() {
		return this.defaultPropertyFeedback('file', Boolean(this.file));
	}

	public namaFeedback() {
		return this.defaultPropertyFeedback('nama');
	}

	public tahunFeedback() {
		return this.defaultPropertyFeedback('tahun');
	}

	public pendidikanFeedback() {
		return this.defaultPropertyFeedback('pendidikan');
	}

	public table() {
		const {
			nama, tahun, pendidikan
		} = this;
		return {
			nama, tahun, pendidikan
		};
	}

	public static columnName(): Array<TableColumn> {
		const table = new Seragam().table();
		let keys = Object.keys(table);

		return keys.map((field: any) => {
			const tableColumn = new TableColumn();
			tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

			return tableColumn;
		});
	}
}
